
Greenmile.RouteMonitor = Greenmile.RouteMonitor || {};
Greenmile.RouteMonitor.RightPanel = (function () {

    var RouteMonitorRightPanel = function () {

        this.floatIcon = null;

        this.init =  () => {

            this.DOMContainer = document.querySelector('#Maps .container');

            this.createFloatIcon();
            this.createRightPanelContainer();
        };

        this.createFloatIcon = function () {

            this.floatIcon = document.createElement('div');
            this.floatIcon.className = 'routeMonitorFloatIcon';

            this.floatIcon.addEventListener('click', this.togglePanel.bind(this));

            this.DOMContainer.appendChild(this.floatIcon);

        };

        this.createRightPanelContainer = function () {

            this.rightPanel = document.createElement('div');
            this.rightPanel.className = 'routeMonitorRightPanel';
            this.rightPanel.style.transform = 'translateX(0)';

            const adjustsLayoutContainer = document.querySelector('#Maps .container #adjustsLayoutContainer');

            const storageMapPosition = new Greenmile.Storage.StoreMapPosition();
            const screenSession  = storageMapPosition.checkScreenOnLocalStorage('RouteMonitor');

            const header = document.createElement('div');
            const title = document.createElement('div');
            const titleIcon = document.createElement('div');
            const titleClose = document.createElement('div');
            const headerLabel = document.createElement('div');

            if (screenSession === null || screenSession.show) {

              this.rightPanel.style.transform = 'translateX(0)';
              adjustsLayoutContainer.style.width = 'calc(100% - 350px)';

            } else {

              this.rightPanel.style.transform = 'translateX(350px)';
              adjustsLayoutContainer.style.width = '100%';

            }

            this.body = document.createElement('div');

            header.className = 'routeMonitorRightPanelHeader';
            title.className = 'routeMonitorRightPanelTitle';
            titleIcon.className = 'routeMonitorRightPanelTitleIcon';
            titleClose.className = 'routeMonitorRightPanelTitleClose';
            headerLabel.className = 'routeMonitorRightPanelLabel';

            this.body.className = 'routeMonitorRightPanelBody';

            titleClose.title = Monet.I18n.getResourcesByKey('default.button.close');

            titleClose.addEventListener('click', this.togglePanel.bind(this));

            title.innerHTML = Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.moreptions');

            header.appendChild(title);
            header.appendChild(titleIcon);
            header.appendChild(titleClose);
            header.appendChild(this.createPanelIconActions());
            header.appendChild(headerLabel);
            header.appendChild(this.body);

            this.rightPanel.appendChild(header);

            this.DOMContainer.appendChild(this.rightPanel);

            if( Monet.Security.checkKeyIsEnabled(['TRACKER_EVENT_NOTIFICATION']) ) {
              this.callEventsPanelFunction();
            } else {
              this.callConfigureMapMarkerLayerFunction();
            }

        };

        this.createPanelIconActions = function () {

            const iconContainer = document.createElement('div');

            const eventIcon = document.createElement('div');
            const mapMarker = document.createElement('div');
            const geofenceTags = document.createElement('div');
            const equipmentTags = document.createElement('div');
            const mapLayers = document.createElement('div');
            const pois = document.createElement('div');

            iconContainer.className = 'panelHeaderContainer';

            eventIcon.className = 'headerIcon panelHeaderEventIcon';
            mapMarker.className = 'headerIcon panelHeaderMapMarker';
            geofenceTags.className = 'headerIcon panelHeaderGeofenceTags';
            equipmentTags.className = 'headerIcon panelHeaderEquipmentTags';
            pois.className = 'headerIcon panelHeaderPOIs';

            let eventIconActive = false;
            let mapMarkerActive = false;
            let eventIconTitle = Monet.I18n.getResourcesByKey('Map.LeftPane.Notifications');

            if( Monet.Security.checkKeyIsEnabled(['TRACKER_EVENT_NOTIFICATION']) ) {
              eventIconActive = true;
              eventIcon.addEventListener('click', this.callEventsPanelFunction.bind(this));
            } else {
              eventIconTitle = " (" + Monet.I18n.getResourcesByKey("Greenmile.GroupPermission.default") + ")";
              mapMarkerActive = true;
            }
            eventIcon.title = eventIconTitle;
            eventIcon.setAttribute('active', eventIconActive);
            mapMarker.setAttribute('active', mapMarkerActive);

            mapMarker.title = Monet.I18n.getResourcesByKey('Toolbar.hint.makerConfig');
            geofenceTags.title = Monet.I18n.getResourcesByKey('Toolbar.hint.tags.geocode');
            equipmentTags.title = Monet.I18n.getResourcesByKey('Toolbar.hint.tags.equipment');
            pois.title = Monet.I18n.getResourcesByKey('Toolbar.hint.pois');

            pois.addEventListener('click', this.callPOILayerFunction.bind(this));
            equipmentTags.addEventListener('click', this.callEquipmentTagLayerFunction.bind(this));
            mapMarker.addEventListener('click', this.callConfigureMapMarkerLayerFunction.bind(this));
            geofenceTags.addEventListener('click', this.callGeofenceLayerFunction.bind(this));

            geofenceTags.setAttribute('active', false);
            equipmentTags.setAttribute('active', false);
            pois.setAttribute('active', false);

            iconContainer.appendChild(eventIcon);
            iconContainer.appendChild(mapMarker);
            iconContainer.appendChild(geofenceTags);
            iconContainer.appendChild(equipmentTags);

            if (
              Monet.Security.checkKeyIsEnabled([
                'PENDINGORDER_LIST',
                'PENDINGORDER_CREATE',
                'PENDINGORDER_UPDATE',
                'PENDINGORDER_DELETE'
              ])
            ) {
              mapLayers.className = 'headerIcon panelHeaderMapLayers';
              mapLayers.title = Monet.I18n.getResourcesByKey(
                'Toolbar.hint.layerMaps'
              );

              mapLayers.addEventListener(
                'click',
                this.callMapLayersFunction.bind(this)
              );
              iconContainer.appendChild(mapLayers);
              mapLayers.setAttribute('active', false);
            }
            
            iconContainer.appendChild(pois);

            return iconContainer;

        };

        this.togglePanel = function () {

            const adjustsLayoutContainer = document.querySelector('#Maps .container #adjustsLayoutContainer');
            const btnIcon = document.querySelector('#Maps div.panelHeaderContainer > div.headerIcon.panelHeaderEventIcon');
            const Storage = new Greenmile.Storage.StoreMapPosition();

            if (this.rightPanel.style.transform === 'translateX(350px)') {

                btnIcon.click();

                this.rightPanel.style.transform = 'translateX(0)';
                adjustsLayoutContainer.style.width = 'calc(100% - 350px)';
                Storage.setSideBarExpandFromUser('RouteMonitor', true);

            } else {

                this.rightPanel.style.transform = 'translateX(350px)';
                adjustsLayoutContainer.style.width = '100%';
                Storage.setSideBarExpandFromUser('RouteMonitor', false);
            }

            if (Monet.Session.mainMap?.map) {
              setTimeout(function () {
                  Monet.Session.mainMap.map.invalidateSize();
              }, 350);

              setTimeout(function () {
                  Monet.Session.mainMap.map.invalidateSize();
              }, 550);
            }
        };

        this.toggleActivePanelIcon = function (e) {

            const allPanelIcons = document.querySelectorAll('.panelHeaderContainer .headerIcon');

            if (e) {
                for (let i = 0, len = allPanelIcons.length; i < len; i++) {
                    allPanelIcons[i].setAttribute('active', 'false');
                }

                e.target.setAttribute('active', 'true');
            }

        };

        this.callMapLayersFunction = function (e) {

            this.toggleActivePanelIcon(e);

            const pendingOrders = new Greenmile.Toolbar.MapLayerActions.PendingOrders();
            const pendingList = pendingOrders.render();
            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');

            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Toolbar.hint.layerMaps');

            pendingOrders.map = Monet.Session.mainMap.map;

            this.body.innerHTML = '';
            this.body.appendChild(pendingList);

        };

        this.callPOILayerFunction = function (e) {

            this.toggleActivePanelIcon(e);

            this.body.innerHTML = '<div class="poisList"> <li> <ul></ul></li></div>';

            const map = Monet.Session.mainMap.map;

            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');
            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Toolbar.hint.pois');

            const layer = new Greenmile.Toolbar.Map.POISControl('.routeMonitorRightPanelBody', map);

            layer.addListeners();

        };

        this.callEquipmentTagLayerFunction = function (e) {

            this.toggleActivePanelIcon(e);

            this.body.innerHTML = '<div class="tagsContainer tagsEquipment"><ul></ul></div>';

            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');
            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Toolbar.hint.tags.equipment');

            const map = Monet.Session.mainMap.map;
            const layer = new Greenmile.Toolbar.Map.Tags(map, '.routeMonitorRightPanelBody', new Greenmile.Toolbar.Map.TagsEquipmentActions(map, ''));
            layer.render();
        };

        this.callConfigureMapMarkerLayerFunction = function (e) {

            this.toggleActivePanelIcon(e);

            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');
            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Toolbar.hint.makerConfig');

            this.body.innerHTML = '<div class="listOrganization"></div>';
            const layer = new Greenmile.Toolbar.Map.ConfigInfoTruckMarker('.routeMonitorRightPanelBody');
            layer.addListeners();

        };

        this.callGeofenceLayerFunction = function (e) {

            this.toggleActivePanelIcon(e);

            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');
            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Toolbar.hint.tags.geocode');

            this.body.innerHTML = '<div class="tagsContainer tagsGeofence"><ul></ul></div>';

            const map = Monet.Session.mainMap.map;
            const selector = '.routeMonitorRightPanelBody';
            const action = new Greenmile.Toolbar.Map.TagsGeofenceActions(map);
            action.setSelector(selector);
            const layer = new Greenmile.Toolbar.Map.Tags(map, selector, action);
            layer.render();

        };

        this.callEventsPanelFunction = function (e) {

            this.toggleActivePanelIcon(e);

            const labelContainer = this.DOMContainer.querySelector('.routeMonitorRightPanelLabel');
            labelContainer.innerHTML = Monet.I18n.getResourcesByKey('Map.LeftPane.Notifications');

            App.Objects.RouteMonitorRightPanelEvents = new Greenmile.RouteMonitor.RightPanelEvents();
            App.Objects.RouteMonitorRightPanelEvents.init();

        };


    };

    return RouteMonitorRightPanel;

}());
